<template>
  <div class="material mb-3 border px-3 py-1 mx-0" :id="randomId" :class="{ 'material-auto': isAuto() }">
    <CRow v-if="isAuto()" class="auto-hint-row px-3 pt-3">
      <CCol sm="12" class="p-0">
        <div
          class="auto-hint"
          v-c-tooltip="{content: 'Dieser Eintrag wurde automatisch aus einem Tageskalender-Eintrag für den ausgewählten Kunden übernommen.', placement:'top'}"
        >
          <CIcon name="cilWarning" class="mr-2"/>
          <span>Aus dem Tageskalender übernommen</span>
        </div>
      </CCol>
    </CRow>
    <CRow class="material full-repeater-row">
      <input type="hidden" name="auto" v-model="localArbeitszeit.auto"/>
      <input type="hidden" name="tageskalenderid" v-model="localArbeitszeit.tageskalenderid"/>
      <CCol sm="10" md="4" class="p-0">
        <CRow>
          <CCol class="mt-3" sm="12" md="6">
            <ArbeitszeitDatum v-model="localArbeitszeit.datum" form-label="Datum" />
          </CCol>
          <CCol class="mt-3" sm="12" md="6">
            <ArbeitszeitNumber :rules="rules" v-model="localArbeitszeit.dauer" placeholder="Dauer" form-label="Dauer" />
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12" md="3" class="mt-3">
        <MitarbeiterAuswahl v-model="localArbeitszeit.mitarbeiter" form-label="Mitarbeiter*" />
      </CCol>
      <CCol sm="12" md="3" class="mt-3 mb-4">
        <ArbeitszeitText v-model="localArbeitszeit.taetigkeit" form-label="Tätigkeit" rules="" />
      </CCol>
      <CCol class="mt-4 text-right p-0 m-auto" sm="10" md="2">
        <CButton
          color="danger"
          variant="outline"
          size="lg"
          class="ml-2 center vertical-middle"
          v-c-tooltip="{content: 'Löschen', placement:'left'}"
          v-on:click="deleteEntry(randomId)"
        >
          <CIcon name="cil-trash"/>
        </CButton>
      </CCol>
    </CRow>
    <CRow class="tageskalender d-sm-down-none" v-if="isAuto() && localArbeitszeit.bilder.length > 0">
      <CCol sm="2" class="ml-3 font-italic font-sm">
        <CIcon name="cil-image" class="mr-1"/>
        Bilder aus Tageskalender:
      </CCol>
      <CCol sm="1" v-for="(bild, index) in localArbeitszeit.bilder" v-bind:key="'bild' + index">
        <Bild :bild="bild" type="tageskalender"/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ArbeitszeitDatum from '@/components/FormElements/Date'
import ArbeitszeitNumber from '@/components/FormElements/Number'
import MitarbeiterAuswahl from '@/components/MitarbeiterAuswahl'
import ArbeitszeitText from '@/components/FormElements/Text'
import Bild from '@/components/Bild'

export default {
  name: 'formular-arbeitszeit',
  components: {
    ArbeitszeitNumber,
    ArbeitszeitText,
    ArbeitszeitDatum,
    MitarbeiterAuswahl,
    Bild
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      rules: 'required',
      randomId: 'repeater-row-arbeitszeit-' + this.getRandomInt(10000)
    }
  },
  mounted () {
    // Defaults Faken für vue-repeater
    this.$emit('input', this.localArbeitszeit)
  },
  watch: {
    localArbeitszeit: {
      deep: true,
      handler: function () {
        this.$emit('input', this.localArbeitszeit)
      }
    }
  },
  computed: {
    localArbeitszeit () {
      const user = this.$store.getters['security/user']
      const value = this.value || {}
      const isInitialized = [
        'datum',
        'dauer',
        'mitarbeiter',
        'taetigkeit',
        'auto'
      ].every((property) => Object.prototype.hasOwnProperty.call(value, property)) &&
        value.randomId === this.randomId

      // Once the parent has accepted the initialized value, keep the same
      // object reference. Returning a fresh object here on every parent update
      // retriggers the deep watcher and creates an endless input/update loop.
      if (isInitialized) {
        return value
      }

      return {
        datum: new Date(),
        dauer: null,
        mitarbeiter: user.userid,
        taetigkeit: '',
        auto: false,
        ...value,
        randomId: this.randomId
      }
    }
  },
  methods: {
    isAuto: function () {
      let result = false
      if ('auto' in this.localArbeitszeit) {
        result = this.localArbeitszeit.auto
      }
      return result
    },
    getRandomInt (max) {
      return Math.floor(Math.random() * max)
    },
    deleteEntry (entry) {
      this.$emit('remove')
      // document.getElementById(entry).remove()
      this.$eventBus.$emit('remove-time-entry', this.localArbeitszeit)
    }
  }
}
</script>

<style lang="scss">
  .repeater-drop-zone:first-child button[title="Remove block"]{
    display: none !important;
  }
  .repeater-drop-zone button[content="Duplicate"]{
    display: none !important;
  }

  div.material {
    &.material-auto {
      border-color: #f0ad4e !important;
      background: #fff8e1;
      box-shadow: inset 4px 0 0 #f0ad4e;
    }

    div.auto-hint {
      display: inline-flex;
      align-items: center;
      padding: 0.35rem 0.65rem;
      border-radius: 999px;
      font-size: 0.85rem;
      font-weight: 600;
      color: #7a4b00;
      background: #ffe7ad;
      cursor: help;
    }

  }
</style>
